import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, Hammer, Rocket, TrendingUp } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const ICONS = [Lightbulb, Hammer, Rocket, TrendingUp];

export default function WhatWeDo() {
  const { t } = useLang();

  return (
    <section id="what" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#00F0FF]">
              {t.what.eyebrow}
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tighter text-white">
              {t.what.title}
            </h2>
            <p className="mt-5 max-w-md text-base text-[#8B95A5] leading-relaxed">
              {t.what.sub}
            </p>
          </div>
          <div className="md:col-span-7 grid sm:grid-cols-2 gap-4">
            {t.what.cards.map((c, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div
                  key={c.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.6, delay: i * 0.08 }}
                  data-testid={`what-card-${i}`}
                  className="glass-card glass-card-hover rounded-2xl p-6 group"
                >
                  <div className="flex items-center justify-between">
                    <span className="text-[11px] tracking-[0.22em] text-white/40 font-display">
                      0{i + 1}
                    </span>
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/[0.03] text-[#00F0FF] group-hover:border-[#00F0FF]/40 transition-colors">
                      <Icon className="h-4 w-4" />
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-xl text-white">{c.title}</h3>
                  <p className="mt-3 text-sm text-[#8B95A5] leading-relaxed">
                    {c.body}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
